import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


import products from './modules/products'
import shops from './modules/shops'
import blog from './modules/blog'
import video from './modules/video'
import adigeya from './modules/adigeya'
import volgograd from './modules/volgograd'
import krasnodar from './modules/krasnodar'
import novoshahtinsk from './modules/novoshahtinsk'
import taganrog from './modules/taganrog'
import novocherkask from './modules/novocherkask'
import shahti from './modules/shahti'
import aksay from './modules/aksay'
import bataysk from './modules/bataysk'
import chrltir from './modules/chrltir'

export default new Vuex.Store ({
	modules: {
		products,
		shops,
		blog,
		video,
		adigeya,
		volgograd,
		krasnodar,
		novoshahtinsk,
		taganrog,
		novocherkask,
		shahti,
		aksay,
		bataysk,
		chrltir
	}
})